import { Filters } from '../../_flux/constants/filter/filters';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import RegoLookupStore from '../../_flux/stores/rego_lookup_store';
import { applyFilters } from '../../_flux/helper/apply_filters';
import { getAbsoluteValueForSpeedIndex } from '../../_modules/tyre_index/get_absolute_value_for_speed_index';
import { requestSetConfiguratorSource } from '../../_modules/requests/request_set_configurator_source';
import { requestSaveVehicleConfiguratorSelection } from '../../_modules/requests/request_save_vehicle_selection';
import { showPostcodeInvalidAction, hidePostcodeInvalidAction, submitRegoLookupForm } from '../../_flux/actions/rego_lookup_actions';
import {
    showAction as lockUi,
    hideAction as unlockUi
} from '../../_flux/actions/ui_lock_actions';
import { validatePostcode } from '../../validator/PostcodeAutocompleteValidator';
import { resetConfiguratorData } from '../configurator_buttons/configurator_buttons';
import CheckoutConfiguratorAnalytics from '../../_modules/google_analytics/checkout_configurator';

export function onSubmitShopFactory() {
    return () => {
        const { values, tyreOptions, vehicleData, touched, postcodeSuggestion } = RegoLookupStore.getState();
        const isVehicleDetails = location.pathname.indexOf('/checkout/') !== -1;
        if (
            values.postcode === '' ||
            (values.postcode && validatePostcode(TYROOLA.globals.store, values.postcode, postcodeSuggestion, touched))
        ) {
            CheckoutConfiguratorAnalytics.customerSubmittedSelectVehicleRegoLookupAction();
            hidePostcodeInvalidAction();
            let tyreSize = values[Filters.VEHICLE_TYRES].split('|');
            let speedIndexAbsValue = getAbsoluteValueForSpeedIndex(tyreSize[5]);
            let filters = {
                [Filters.WIDTH]: tyreSize[0],
                [Filters.HEIGHT]: tyreSize[1],
                [Filters.DIAMETER]: tyreSize[2],
                [Filters.POSTCODE]: values[Filters.POSTCODE],
            };

            if (tyreSize[4] && tyreSize[4].length > 0 && tyreSize[4] !== 'undefined') {
                filters[Filters.LOAD_INDEX] = parseInt(tyreSize[4]);
            }

            if (Number.isInteger(speedIndexAbsValue) && speedIndexAbsValue > 0) {
                filters[Filters.SPEED_INDEX] = speedIndexAbsValue;
            }

            updateFiltersAction(filters);

            lockUi();
            submitRegoLookupForm();
            requestSetConfiguratorSource('rego_lookup')
                .then(() => {
                    requestSaveVehicleConfiguratorSelection(values, tyreOptions, vehicleData).then(() => {
                        if (!isVehicleDetails) {
                            applyFilters('tyre', 'rego_lookup');
                        } else {
                            resetConfiguratorData();
                            unlockUi();
                        }
                    });
                })
                .done()
                .catch(() => {
                    unlockUi();
                });
        } else {
            showPostcodeInvalidAction();
        }
    }
}
